import React from 'react';
import { formatPhoneNumber } from '../../common';

const PatientAppointmentContactInfo = ({ selectedAppointment }) => {
    if (!selectedAppointment.created_by_user) {
        return null;
    }

    const { created_by_user, zip_code } = selectedAppointment;

    const getFormattedPhoneNumber = () => {
        console.log('created_by_user object:', created_by_user);
        console.log('Available properties:', Object.keys(created_by_user));
        console.log('phoneNum:', created_by_user.phoneNum);
        console.log('phone:', created_by_user.phone);
        console.log('phone_no:', created_by_user.phone_no);
        
        return formatPhoneNumber(
            created_by_user.phoneNum || 
            created_by_user.phone || 
            created_by_user.phone_no || 
            'Not available'
        );
    };

    return (
        <div className="border-b border-gray-200 pb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                    <div className="text-sm font-semibold text-gray-500 mb-2">Email</div>
                    <div className="text-base font-medium text-gray-800 break-all">
                        {created_by_user.email}
                    </div>
                </div>
                <div>
                    <div className="text-sm font-semibold text-gray-500 mb-2">Phone Number</div>
                    <div className="text-base font-medium text-gray-800">
                        {getFormattedPhoneNumber()}
                    </div>
                </div>
                <div>
                    <div className="text-sm font-semibold text-gray-500 mb-2">Zipcode</div>
                    <div className="text-base font-medium text-gray-800">{zip_code}</div>
                </div>
            </div>
        </div>
    );
};

export default PatientAppointmentContactInfo;
